module.exports = __webpack_public_path__ + "media/images/join-as-doctor-ff-bg-a1318c471895645d20afa4d268ae5180.png";